import React, { useState, useEffect, useRef, useMemo } from "react";
import { Form } from "react-bootstrap";
import "components/custom.css";
import { store, persistor } from 'store/index';
// import ItemNumber from "components/PracticeMaterial/New/ItemNumber";
// import TagIcon1 from "assets/images/images_new/tag1.svg";
import TimeUp from "components/PracticeMaterial/PopUps/TimeUp";
import ClockIcon from "assets/images/images_new/clock_1.png";

const LIMIT = 600; // 10 minutes.
// const LIMIT = 10; // testing. 10 seconds.

const Summary = (props) => {
  const [secondCount, setSecondCount] = useState(LIMIT);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [content, setContent] = useState('');
  const [lang, setLang] = useState(store.getState().user.lang);
  const [resultObj, setResultObj] = useState({});
  const [correctFlag, setCorrectFlag] = useState(true);
  const [timeoutStat, setTimeoutStat] = useState(false);
  const [showTimer, setShowTimer] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [inputRows, setInputRows] = useState(1);
  const [scrollHeight, setScrollHeight] = useState(0);

  const intervalIdRef = useRef(null);
  const recordIdRef = useRef(null);

  // const copyToClipboard = () => {
  //   document.execCommand("copy");
  // };

  // const cutToClipboard = () => {
  //   document.execCommand("cut");
  // };

  // const pasteToClipboard = async () => {
  //   alert("Press Ctrl+v for paste text");
  // };

  // const timer = () => {
  //   const { answer } = props;

  //   // keep running timer if question is not submitted.
  //   if (!answer) {
  //     if (secondCount === 1) {
  //       clearInterval(intervalIdRef.current);
  //       setTimeoutStat(true);
  //       setIsOpen(true);
  //     }
  //     setSecondCount(prev => prev - 1);
  //   } else {
  //     // clear interval.
  //     clearInterval(intervalIdRef.current);
  //   }
  // };

  const timer = () => {
  const { answer } = props;

  setSecondCount(prevCount => {
    // If answer is submitted, stop the timer
    if (answer) {
      clearInterval(intervalIdRef.current);
      return prevCount;
    }

    // If time is up
    if (prevCount <= 1) {
      clearInterval(intervalIdRef.current);
      setTimeoutStat(true);
      setIsOpen(true);
      return 0;
    }

    // Continue countdown
    return prevCount - 1;
  });
};

  // const handleTextareaSize = (e) => {
  //   if ((scrollHeight < e.target.scrollHeight)) {
  //     if (inputRows < 7) {
  //       e.target.style.height = "0px";
  //       e.target.style.height = (25 + e.target.scrollHeight) + "px";

  //       setScrollHeight(e.target.scrollHeight);
  //       setInputRows(prev => prev + 1);
  //     }
  //   }
  //   else if (scrollHeight === e.target.scrollHeight) {
  //     e.target.style.height = scrollHeight + "px";
  //     e.target.style.height = (25 - e.target.scrollHeight) + "px";
  //   }
  // };
  const handleTextareaSize = (e) => {
    const textarea = e.target;

    const maxHeight = 241;

    textarea.style.height = "auto";

    if (textarea.scrollHeight > maxHeight) {
      textarea.style.height = maxHeight + "px";
      textarea.style.overflowY = "auto"; // show scrollbar
    } else {
      textarea.style.height = textarea.scrollHeight + "px";
      textarea.style.overflowY = "hidden"; // hide scrollbar
    }
  };

  const chaneText = (e) => {
    let { name, value } = e.target;
    props.showResult();
    const wordLength = value.split(' ').filter(function(n) { return n != '' }).length;
    const newResultObj = {
      'answer': value,
      'correct': '',
      'length': wordLength,
      'time': secondCount,
      lang: lang
    };
    const hasContent = value.trim().length > 0; 
    console.log(hasContent);
    props.submit(newResultObj, hasContent);
    setContent(value);
    setResultObj(newResultObj);
  };

  // const chaneLang = (e) => {
  //   setLang(e.target.value);
  // };

  // const stopTest = () => {
  //   props.nextQuestion({ ...resultObj, time: secondCount });
  // };

  // const updateCorrect = () => {
  //   const newResultObj = {
  //     'answer': '',
  //     'correct': '',
  //     'length': 0,
  //     time: secondCount,
  //     lang: lang
  //   };
  //   props.submit(newResultObj);
  //   setCorrectFlag(false);
  //   setResultObj(newResultObj);
  // };

  const copyFunc = () => {
    return false;
  };

  const timeLeft = () => {
  const totalSeconds = Math.max(0, Math.floor(secondCount));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return ` ${minutes}m:${seconds.toString().padStart(2, "0")}s`
    // return `${Math.floor(secondCount / 60)}m : ${secondCount % 60}s`;
  };

  const wordCount = () => {
    return content === "" ? 0 : content.trim().split(/\s+/).length;
  };

  const toggle = () => {
    setIsOpen(prev => !prev);
  };

  // ComponentDidMount equivalent
  useEffect(() => {
    console.log("Thiis is the Summarize in thewriting")
    if (!props.answer) {
      let intervalId = setInterval(timer, 1000);
      const { isQuestionTime, questionTime } = props;

      if (isQuestionTime) {
        setSecondCount(questionTime * 60);
        setShowTimer(isQuestionTime);
      }

      intervalIdRef.current = intervalId;
    }

    // ComponentWillUnmount equivalent
    return () => {
      clearInterval(intervalIdRef.current);
    };
  }, []);

  // getDerivedStateFromProps equivalent
  useEffect(() => {
    if (props.data) {
      if ((questionId && questionId !== props.data.id) || props.restart) {
        clearInterval(intervalIdRef.current);
        clearInterval(recordIdRef.current);
        const { isQuestionTime, questionTime } = props;
        let newSecondCount = 600;
        let newShowTimer = true;
        if (isQuestionTime) {
          newSecondCount = questionTime * 60;
          newShowTimer = isQuestionTime;
        }
        setTimeoutStat(false);
        setCorrectFlag(true);
        setSecondCount(newSecondCount);
        setShowTimer(newShowTimer);
        setQuestionId(props.data.id);
        setReset(true);
        setContent('');
      } else {
        if (!questionId) {
          setCorrectFlag(true);
          setQuestionId(props.data.id);
          setContent('');
        }
      }
    }
  }, [props.data, props.restart, questionId]);

  // Handle reset effect
  useEffect(() => {
    console.log("This is the  reset")
    if (reset) {
      const intervalId = setInterval(timer, 1000);
      intervalIdRef.current = intervalId;
      setReset(false);
    }
  }, [reset]);

  // // Handle stopRecording
  // useEffect(() => {
  //   if (props.stopRecording) {
  //     stopTest();
  //   }
  // }, [props.stopRecording]);

  // Handle restart
  useEffect(() => {
    if (props.restart) {
      props.restartQue();
    }
  }, [props.restart]);

  // // Handle correctFlag update
  // useEffect(() => {
  //   if (props.data && correctFlag) {
  //     updateCorrect();
  //   }
  // }, [props.data, correctFlag]);

  // let question = "";
  // if (props.data) {
  //   question = props.data.question;
  // }
  
  let question = useMemo(() => {
      return props.data?.question || "";
    }, [props.data?.question]);

  const { resultMode, answer, showResponse } = props;

  return (
    <>
      <div className="custom-box mx-0">
        <p className="gray-text readable unselectable">{question}</p>
      </div>
      
      <div className="editor-wrapper-section custom-box mx-0">
        {!resultMode && !answer && !timeoutStat ? (
          <>                
            <div className="editor-wrapper">
              <div className="editor__toolbar">
                <button className="toolbar__button"></button>
              </div>
              <div className="editor__input">
                {/* <Input
                  type="textarea"
                  className="writing-textarea"
                  onCopy={copyFunc}
                  autoCorrect="false"
                  spellCheck="false"
                  name="content"
                  onChange={(e) => { chaneText(e) }}
                  onKeyUp={handleTextareaSize}
                  value={content}
                  placeholder="Write your response here"
                /> */}
                <Form.Control
  as="textarea"
  className="writing-textarea"
  onCopy={copyFunc}
  autoCorrect="off"
  spellCheck={false}
  name="content"
  onChange={(e) => { chaneText(e) }}
  onKeyUp={handleTextareaSize}
  value={content}
  placeholder="Write your response here"
/>
                {/*!timeoutStat ? (
                  <Input
                    type="textarea"
                    onCopy={copyFunc}
                    autoCorrect="false"
                    spellCheck="false"
                    name="content"
                    onChange={(e) => { chaneText(e)}}
                    value={content}
                    placeholder="write your content here..."
                  />
                ) : (
                  <div style={{
                    whiteSpace: 'pre-line'
                  }}>{content}</div>
                )*/}
              </div>
            </div>

            <div className="clearfix mt-3 sm-flex">
              <div className="time-spent pull-left sm-flex">
                <img src={ClockIcon} alt="Badge" /><span>Time Left:</span> {timeLeft()}
              </div>

              <div className="word-count pull-right">
                <span>Total word count:</span> {wordCount()}
              </div>
            </div>
          </>
        ) : (
          <div className="editor-wrapper">
            <div className="editor__toolbar">
              <button className="toolbar__button"></button>
            </div>
            <div className="editor__input">
              <div style={{
                whiteSpace: 'pre-line'
              }}>{content}</div>
            </div>
          </div>
        )}
      </div>
       {!answer && 
        <TimeUp
        isOpen={isOpen}
        toggle={toggle}
        title="Time up !!!"
        message="You have used up all your allotted time for this question."
        buttonLabel="Submit Now"
        showResponse={showResponse}
        allowClose={true}
        // submitDisable={content.trim().length === 0}
        submitDisable={props.submitDisable}
      />}
    </>
  );
};

export default Summary;